import type { FC, SVGAttributes } from 'react';
import React from 'react';

export const IconError: FC<SVGAttributes<SVGElement>> = props => (
    <svg height="18" viewBox="0 0 18 18" width="18" {...props}>
        <path d="M9 18c4.962 0 9-4.038 9-9s-4.038-9-9-9-9 4.038-9 9 4.038 9 9 9z" fill="#F03226" />
        <path
            d="M5.918 13L9 9.918 12.082 13l.918-.918L9.918 9 13 5.918 12.082 5 9 8.082 5.918 5 5 5.918 8.082 9 5 12.082l.918.918z"
            fill="#fff"
        />
    </svg>
);
